export class EncodeDecode {
  static b64EncodeUnicode(str: any, replace: boolean = true) {
    let base = encodeURIComponent(str);
    if (replace) {
      base = base.replace(/%([0-9A-F]{2})/g, (match, p1) => {
        return String.fromCharCode(('0x' + p1) as any);
      });
    }
    return btoa(base);
  }

  static b64DecodeUnicode(str) {
    // Going backwards: source bytestream, to percent-encoding, to original string.
    return decodeURIComponent(
      atob(str)
        .split('')
        .map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join(''),
    );
  }
}
